module.exports = __webpack_public_path__ + "img/i-role-min6.554e5204.png";